import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToTreePipe } from './to-tree.pipe';

@NgModule({
  declarations: [ToTreePipe],
  imports: [
    CommonModule,
  ],
  exports: [ToTreePipe]
})
export class ToTreeModule { }
